var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-phone-setting',{staticClass:"pt-phone-setting__page"})
}
var staticRenderFns = []

export { render, staticRenderFns }